/* Utilities */

import { createSelector } from 'reselect'

const playlist = (state) => state.playlist
const createdPlaylistTid = (state, props) => props.tid

export const getList = createSelector(
  [ playlist ],
  (playlist) => {
    return Object.assign(
      {},
      { list: playlist.list.list }
    )
  }
)

export const getCreatedList = createSelector(
  [ playlist ],
  (playlist) => {
    return Object.assign(
      {},
      { createdList: playlist.list.createdList }
    )
  }
)

export const getFilter = createSelector(
  [ playlist ],
  (playlist) => {
    return Object.assign(
      {},
      { filter: playlist.list.filter }
    )
  }
)

export const getSort = createSelector(
  [ playlist ],
  (playlist) => {
    return Object.assign(
      {},
      { sort: playlist.list.sort }
    )
  }
)

export const getPagination = createSelector(
  [ playlist ],
  (playlist) => {
    return Object.assign(
      {},
      {
        pagination: playlist.list.pagination
      }
    )
  }
)

export const getQuery = createSelector(
  [ playlist ],
  (playlist) => {
    return Object.assign(
      {},
      {
        query: playlist.list.query
      }
    )
  }
)

export const getCreatedItem = createSelector(
  [ playlist, createdPlaylistTid ],
  (playlist, createdPlaylistTid) => {
    return Object.assign(
      {},
      playlist.list.created[createdPlaylistTid]
    )
  }
)

export const getItem = (state, uid) => {
  const {
    items,
    expanded,
  } = state.playlist.list

  let item = (items[uid])?items[uid]:{pending:true}

  if (!item.pending) {
    let count = 0
    if (items[uid].mediaObjects) {
      count = items[uid].mediaObjects.length
    }
    item.mediaObjectCount = count
    item.expanded = expanded[uid]
  }
  return Object.assign(
    {},
    item,
    { uid },
  )
}

export const getPlaylistAsset = (state, uid, index) => {
  const {
    items
  } = state.playlist.list
  if (items[uid].mediaObjects) {
    const organizationSchedule = state.user && state.user.organizationSchedule || false
    const mediaObject = items[uid].mediaObjects[index]
    const asset = state.asset.list.items[mediaObject.assetId]
    const duration = (asset && asset.duration)?assetDuration:0
    return Object.assign(
      {},
      asset,
      mediaObject,
      { organizationSchedule },
      { assetId: mediaObject.assetId },
      { uid, index, assetDuration: duration }
    )
  } else {
    return {}
  }
}

export const getAssetsMetaData = (state) => {
  return state.asset.list.items
}



// WEBPACK FOOTER //
// ./src/app/react-redux/selectors/playlist.js